let downloadButtonActionView = jQuery('div.designViewDownload'),
    downloadButtonListView = jQuery('div.selectActionButton\\-Download'),
    downloadPopUp = jQuery("div.popupActions[data-selection-action='Download']"),
    downloadPopupType = jQuery("select[name='download\\_type']", '.popupPlatform'),
    downloadPopupLength = jQuery("select[name='download\\_length']", '.popupPlatform'),
    downloadPopupLoop = jQuery("select[name='download\\_loop']", '.popupPlatform'),
    downloadPopupSpeed = jQuery("select[name='download\\_speed']", '.popupPlatform'),
    downloadPopupFPS = jQuery("select[name='download\\_format']", '.popupPlatform'),
    downloadNowPopupButtonText = jQuery("div.downloadNowPopButton", '.popupPlatform'),
    maxDownloadSize = jQuery("strong.maxDownloadSize", '.popupPlatform'),
    downloadFormat = jQuery("select[name='download\\_format']", '.popupPlatform'),
    downloadFormatInput = downloadFormat.closest('.inputSelect'),
    shareDesignInDownloadLink = jQuery('div.a2a_kit'),
    downloadPopup = jQuery("form.popupDownloadForm");

$(document).ready(function () {
    const hash = location.hash.substr(1);
    if (hash == 'downloadNow') {
        downloadButtonActionView.trigger('click');
    }
});

function getFileNameByContentDisposition(contentDisposition) {
    let regex = /filename[^;=\n]*=(UTF-8(['"]*))?(.*)/;
    let matches = regex.exec(contentDisposition);
    let filename;

    if (matches != null && matches[3]) {
        filename = matches[3].replace(/['"]/g, '');
    }
    // console.log(contentDisposition, filename);
    return decodeURI(filename);
}

downloadNowPopupButtonText.unbind('click');
downloadNowPopupButtonText.bind('click', function (event) {
    let form = $(this).parent('form'), url = form.attr('action');
    let formData = new FormData(document.getElementById('popupDownloadForm'));
    downloadNowPopupButtonText.html("Downloading...");
    downloadNowPopupButtonText.addClass('downloadNowPopButtonDownloading');
    fetch(url, {
        method: 'POST',
        body: formData,
    }).then((resp) => {
        window.responseHeaders = resp.headers;
        downloadPopUp.removeClass('active');
        downloadNowPopupButtonText.removeClass('downloadNowPopButtonDownloading');
        return resp.blob(); // or resp.text() or whatever the server sends
    }).then(function (blob) {
        let headerContentDisposition = window.responseHeaders.get('Content-Disposition');
        if (typeof headerContentDisposition !== "undefined" && headerContentDisposition !== null) {
            downloadCustom(blob, getFileNameByContentDisposition(window.responseHeaders.get('Content-Disposition')), window.responseHeaders.get('content-type'));
        } else {
            form.submit();
        }
        downloadNowPopupButtonText.removeClass('downloadNowPopButtonDownloading');
        downloadPopUp.removeClass('active');
    });

});
//
// downloadPopup.unbind('submit');
// downloadPopup.bind('submit', function (event) {
//     event.preventDefault();
//     event.stopPropagation();
//     let form = jQuery(event.target),
//         url = form.attr('action'),
//         formData = new URLSearchParams(new FormData(event.target));
//     event.preventDefault();
//     event.stopPropagation();
//     downloadNowPopupButtonText.val("Downloading...");
//     downloadNowPopupButtonText.addClass('downloadNowPopButtonDownloading');
//
//     axios(url, {
//         method: 'POST',
//         body: formData,
//     }).then((resp) => {
//         window.responseHeaders = resp.headers;
//         downloadPopUp.removeClass('active');
//         downloadNowPopupButtonText.removeClass('downloadNowPopButtonDownloading');
//         return resp.blob(); // or resp.text() or whatever the server sends
//     }).then(function (blob) {
//         let headerContentDisposition = window.responseHeaders.get('Content-Disposition');
//         if (typeof headerContentDisposition !== "undefined" && headerContentDisposition !== null) {
//             downloadCustom(blob, getFileNameByContentDisposition(window.responseHeaders.get('Content-Disposition')), window.responseHeaders.get('content-type'));
//         } else {
//             event.currentTarget.submit();
//         }
//         downloadNowPopupButtonText.removeClass('downloadNowPopButtonDownloading');
//         downloadPopUp.removeClass('active');
//     });
//
// });

downloadButtonActionView.unbind('click');
downloadButtonActionView.bind('click', function () {
    let $this = jQuery(this),
        design = jQuery('.designViewBlock'),
        designId = design.data('selectionId'),
        designType = $this.children().data('designType'),
        designSize = $this.children().data('designSize');
    shareDesignInDownloadLink.attr("data-a2a-url", $(location).attr('href'));

    if (downloadPopup.hasClass('active')) {
        if (designType == 'mp4') {
            downloadPopupLength.parent().show();
            downloadPopupSpeed.parent().show();
        }
    }
    if (!downloadPopup.hasClass('active')) {
        if (designType == 'rendered-animation') {
            downloadPopupLength.parent().show();
            downloadPopupSpeed.parent().show();
        }
    }
    initDownload(designId, designSize, designType);

});

downloadButtonListView.unbind('click');
downloadButtonListView.bind('click', function () {
    let $this = jQuery(this),
        design = $this.closest('.designsGridItem'),
        designId = design.data('selectionId'),
        designType = jQuery('.selectActionButton\\-Download', design).data('designType'),
        designSize = jQuery('.designSize', design).text().replace(/ /g, ''),
        currentDesignLink = jQuery('.designGridItemImg', design).children('a').attr("href");
    shareDesignInDownloadLink.attr("data-a2a-url", currentDesignLink);
    if (!downloadPopup.hasClass('active')) {
        if (designType == 'rendered-animation') {
            downloadPopupLength.parent().show();
            downloadPopupSpeed.parent().show();
        }
    }
    initDownload(designId, designSize, designType);

});


function initDownload($designId, $designSize, $designType) {
    let downloadTypesOptions = jQuery("option", downloadPopupType),
        sizeAsArray = $designSize.split('×'),
        downloadWidth = jQuery("input[name='download\\_width']", '.popupPlatform'),
        downloadHeight = jQuery("input[name='download\\_height']", '.popupPlatform'),
        ratioWidth = sizeAsArray[0] / sizeAsArray[1],
        ratioHeight = sizeAsArray[1] / sizeAsArray[0],
        designIdInput = jQuery("input[name='design\\_id']", '.popupPlatform'),
        downloadUserRole = downloadPopup.data('role');
    downloadPopupLoop.parent().hide();
    downloadNowPopupButtonText.text("Download " + jQuery('option:selected', downloadPopupType).text());
    designIdInput.val($designId);
    maxDownloadSize.text($designSize);
    downloadFormatInput.hide();
    downloadWidth.on('keyup', function (event) {
        $(this).val($(this).val().replace(/[^\d].+/, ""));
        if ((event.which < 48 || event.which > 57)) {
            event.preventDefault();
        }
    });
    setMaxOnInput(downloadWidth, sizeAsArray[0]);
    setMaxOnInput(downloadHeight, sizeAsArray[1]);
    downloadWidth.val(sizeAsArray[0]);
    downloadWidth.on('change keyup', function () {
        // $(this).val($(this).val().replace(/[^\d].+/, ""));
        // if ((event.which < 48 || event.which > 57)) {
        //     event.preventDefault();
        // }

        let newHeight = Math.round(downloadWidth.val() * ratioHeight);
        console.log(newHeight, newHeight, ratioHeight);
        if (newHeight <= sizeAsArray[1]) {
            downloadHeight.val(newHeight);
        } else {
            downloadHeight.val(sizeAsArray[1]);
        }
        console.log(sizeAsArray[0]);
        // setMaxOnInput(downloadHeight, downloadHeight.val());
        // setMaxOnInput(downloadWidth, sizeAsArray[0]);

    });
    downloadHeight.on('keyup', function (event) {
        $(this).val($(this).val().replace(/[^\d].+/, ""));
        if ((event.which < 48 || event.which > 57)) {
            event.preventDefault();
        }
    });
    downloadHeight.val(sizeAsArray[1]);
    downloadHeight.on("change keyup", function () {
        let newWidth = Math.round(downloadHeight.val() * ratioWidth);
        console.log(newWidth, downloadHeight.val(), ratioWidth);
        if (newWidth <= sizeAsArray[0]) {
            downloadWidth.val(newWidth);
        } else {
            downloadWidth.val(sizeAsArray[0]);
        }
        // setMaxOnInput(downloadWidth, downloadWidth.val());
        // setMaxOnInput(downloadWidth, sizeAsArray[1]);
    });
    if ($designType == 'image') {
        downloadPopupType.empty();
        downloadPopupType.append($('<option>', {value: 'png', text: 'PNG'}));

        if (downloadUserRole == 'free') {
            downloadPopupType.append($('<option>', {value: 'jpg', text: 'JPG (Premium plans)', disabled: true}));
            downloadPopupType.append($('<option>', {value: 'pdf', text: 'PDF (Premium plans)', disabled: true}));
            downloadPopupType.append($('<option>', {value: 'webpImage', text: 'WEBP (Premium plans)', disabled: true}));
        } else {
            downloadPopupType.append($('<option>', {value: 'jpg', text: 'JPG'}));
            downloadPopupType.append($('<option>', {value: 'webpImage', text: 'WEBP'}));
            downloadPopupType.append($('<option>', {value: 'pdf', text: 'PDF'}));
        }
        downloadTypesOptions.eq(0).prop('selected', true).change();
        downloadPopupLength.parent().hide();
        downloadPopupSpeed.parent().hide();
    } else {
        if (downloadUserRole === 'pro') {
            // downloadPopup.show();
        }

        downloadPopupType.empty();
        downloadFormat.empty();
        downloadPopupFPS.empty();
        downloadPopupLoop.empty();
        downloadPopupLength.empty();
        downloadPopupSpeed.empty();
        downloadPopupType.append($('<option>', {value: 'mp4', text: 'MP4'}));
        if (downloadUserRole == 'free' || downloadUserRole == 'pro') {
            // downloadPopup.hide();
            downloadPopupType.append($('<option>', {value: 'gif', text: 'GIF (Diamond plan)', disabled: true}));
            downloadPopupType.append($('<option>', {value: 'webpVideo', text: 'WEBP (Diamond plan)', disabled: true}));
            downloadPopupFPS.append($('<option>', {
                value: 10,
                selected: 'selected',
                text: '10 FPS - normal size / quality'
            }));
            downloadPopupFPS.append($('<option>', {
                value: 5,
                text: '5 FPS - small size / low quality',
                disabled: true
            }));
            downloadPopupFPS.append($('<option>', {
                value: 15,
                text: '15 FPS - big size / high quality',
                disabled: true
            }));


            downloadPopupLength.append($('<option>', {value: 1, selected: 'selected', text: '1x Length (default)'}));
            downloadPopupLength.append($('<option>', {
                value: 2,
                text: '2x Length - Double video length',
                disabled: true
            }));
            downloadPopupLength.append($('<option>', {
                value: 3,
                text: '3x Length - Triple video length',
                disabled: true
            }));
            downloadPopupLength.append($('<option>', {
                value: 5,
                text: '5x Length - Increase length 5x',
                disabled: true
            }));
            downloadPopupLength.append($('<option>', {
                value: 10,
                text: '10x Length - Increase length 10x',
                disabled: true
            }));


            downloadPopupSpeed.append($('<option>', {
                value: 4,
                text: '0.25× Speed - Decrease speed 4×',
                disabled: true
            }));
            downloadPopupSpeed.append($('<option>', {
                value: 2,
                text: '0.5× Speed - Decrease speed 2×',
                disabled: true
            }));
            downloadPopupSpeed.append($('<option>', {
                value: 1.33,
                text: '0.75× Speed - Decrease speed 1.5×',
                disabled: true
            }));
            downloadPopupSpeed.append($('<option>', {value: 1, selected: "selected", text: '1× Speed (normal)'}));
            downloadPopupSpeed.append($('<option>', {
                value: 0.75,
                text: '1.25× Speed - Increase speed 1.25×',
                disabled: true
            }));
            downloadPopupSpeed.append($('<option>', {
                value: 0.66,
                text: '1.5× Speed - Increase speed 1.5×',
                disabled: true
            }));
            downloadPopupSpeed.append($('<option>', {
                value: 0.5,
                text: '2× Speed - Increase speed 2×',
                disabled: true
            }));

            downloadPopupLoop.append($('<option>', {
                value: true,
                selected: 'selected',
                text: 'Infinite Loop (default)'
            }));
            downloadPopupLoop.append($('<option>', {
                value: false, text: '1× Loop - animation play once', disabled: true
                }));

        } else {

            downloadPopupType.append($('<option>', {value: 'gif', text: 'GIF'}));
            downloadPopupType.append($('<option>', {value: 'webpVideo', text: 'WEBP'}));

            downloadPopupFPS.append($('<option>', {
                value: 10,
                selected: 'selected',
                text: '10 FPS - normal size / quality'
            }));
            downloadPopupFPS.append($('<option>', {value: 5, text: '5 FPS - small size / low quality'}));
            downloadPopupFPS.append($('<option>', {value: 15, text: '15 FPS - big size / high quality'}));

            downloadPopupLength.append($('<option>', {value: 1, selected: 'selected', text: '1x Length (default)'}));
            downloadPopupLength.append($('<option>', {value: 2, text: '2x Length - Double video length'}));
            downloadPopupLength.append($('<option>', {value: 3, text: '3x Length - Triple video length'}));
            downloadPopupLength.append($('<option>', {value: 5, text: '5x Length - Increase length 5x'}));
            downloadPopupLength.append($('<option>', {value: 10, text: '10x Length - Increase length 10x'}));

            downloadPopupSpeed.append($('<option>', {value: 4, text: '0.25× Speed - Decrease speed 4×'}));
            downloadPopupSpeed.append($('<option>', {value: 2, text: '0.5× Speed - Decrease speed 2×'}));
            downloadPopupSpeed.append($('<option>', {value: 1.33, text: '0.75× Speed - Decrease speed 1.5×'}));
            downloadPopupSpeed.append($('<option>', {value: 1, selected: "selected", text: '1× Speed (normal)'}));
            downloadPopupSpeed.append($('<option>', {value: 0.75, text: '1.25× Speed - Increase speed 1.25×'}));
            downloadPopupSpeed.append($('<option>', {value: 0.66, text: '1.5× Speed - Increase speed 1.5×'}));
            downloadPopupSpeed.append($('<option>', {value: 0.5, text: '2× Speed - Increase speed 2×'}));

            downloadPopupLoop.append($('<option>', {
                value: true,
                selected: 'selected',
                text: 'Infinite Loop (default)'
            }));
            downloadPopupLoop.append($('<option>', {value: false, text: '1× Loop - animation play once'}));

        }
        console.log(jQuery('option:selected', downloadPopupType).val());
        downloadTypesOptions.eq(0).prop('selected', true).change();
    }
    downloadNowPopupButtonText.text("Download " + jQuery('option:selected', downloadPopupType).text());

    downloadPopupType.unbind('change');
    downloadPopupType.bind('change', function () {
        let $this = jQuery(this),
            downloadButtonText = "Download " + jQuery('option:selected', $this).text(),
            selectDownloadType = jQuery('option:selected', downloadPopupType).val();
        downloadNowPopupButtonText.text(downloadButtonText);
        if (selectDownloadType == "gif") {
            let gifAria = sizeAsArray[0] * sizeAsArray[1];

            if (gifAria > 360000) {
                let maxGifWidth = Math.round(Math.sqrt((sizeAsArray[0] * sizeAsArray[0] * 360000) / gifAria)),
                    maxGifHeight = Math.round(Math.sqrt((sizeAsArray[1] * sizeAsArray[1] * 360000) / gifAria));

                if (maxGifWidth < sizeAsArray[0]) {
                    sizeAsArray[0] = maxGifWidth;
                    downloadWidth.val(maxGifWidth);
                    setMaxOnInput(downloadWidth, sizeAsArray[0]);
                } else {
                    downloadWidth.val(sizeAsArray[0]);
                    setMaxOnInput(downloadWidth, sizeAsArray[0]);
                }
                if (maxGifHeight < sizeAsArray[1]) {
                    sizeAsArray[1] = maxGifHeight;
                    downloadHeight.val(maxGifHeight);
                    setMaxOnInput(downloadHeight, maxGifHeight);
                } else {
                    downloadHeight.val(sizeAsArray[1]);
                    setMaxOnInput(downloadHeight, sizeAsArray[1]);
                }
                maxDownloadSize.text(sizeAsArray.join('×'));
            }
            downloadFormatInput.show();
            downloadPopupLength.parent().hide();
            downloadPopupSpeed.parent().hide();
            downloadPopupLoop.parent().hide();
        } else {
            downloadPopupLength.parent().hide();
            maxDownloadSize.text($designSize);
            downloadFormatInput.hide();
            sizeAsArray = $designSize.split('×');
            setMaxOnInput(downloadHeight, sizeAsArray[0]);
            downloadWidth.val(sizeAsArray[0]);
            setMaxOnInput(downloadHeight, sizeAsArray[1]);
            downloadHeight.val(sizeAsArray[1]);
        }
        if (selectDownloadType == "mp4") {
            downloadPopupSpeed.parent().show();
            downloadPopupLength.parent().show();
            downloadPopupLoop.parent().hide();
        }


        if (selectDownloadType == "webpVideo") {
            downloadPopupSpeed.parent().show();
            downloadPopupLoop.parent().show();
        }
    });


    //ADDED BY ALEX
    if (downloadUserRole == 'free') {
        downloadPopUp.addClass('limitedDownload');
    }
    if (downloadUserRole == 'pro') {
        if ($designType == 'image') {
        } else {
            downloadPopUp.addClass('limitedDownload');
        }
    }

    downloadPopUp.addClass('active');
}

function setMaxOnInput(input, max) {

    let value = input.val();

    if ((value !== '') && (value.indexOf('.') === -1)) {
        input.val(Math.max(Math.min(value, max, max)));
    }
}



